import React from 'react';
import { Box, Button } from '@mui/material';

import PdfDocumentCards from 'PdfDocumentGrid/PdfDocumentCards';
import { IDocumentVersion } from 'utils/DexieDBManager';

import { styledDocumentsScroller, styledDocumentsList } from './stylesHomePageDocumentCards';
import FontAwesomeSvgIcon from 'Layouts/Common/FontAwesomeSvgIcon';
import svgFronts from 'Layouts/Common/fontAwesome';

interface IDocumentCardsProps {
  documentVersionsToDisplay: IDocumentVersion[];
}
const HomePageDocumentCards: React.FunctionComponent<IDocumentCardsProps> = ({documentVersionsToDisplay}) => {
  const boxOfCategoriesRef = React.useRef<HTMLDivElement>(null);

  const handleScroll = (scrollOffset: number) => {
    if (boxOfCategoriesRef.current) {
      boxOfCategoriesRef.current.scrollLeft += scrollOffset;
    }
  };

  return (
    <Box id='categorySelector' sx={styledDocumentsScroller}>
      <Button
        sx={{ minWidth: '30px' }}
        onClick={() => handleScroll(-200)}
        aria-label='Previous categories'
        size='small'>
        <FontAwesomeSvgIcon icon={svgFronts.faChevronLeft} />
      </Button>
      <Box sx={styledDocumentsList} ref={boxOfCategoriesRef} className='scroll-categories'>
        <PdfDocumentCards
          documentVersionsToDisplay={documentVersionsToDisplay}
        />
      </Box>
      <Button sx={{ minWidth: '30px' }} onClick={() => handleScroll(200)} aria-label='Next categories' size='small'>
        <FontAwesomeSvgIcon icon={svgFronts.faChevronRight} />
      </Button>
    </Box>
  );
};

export default HomePageDocumentCards;
